import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "examplePage" }
const _hoisted_2 = { class: "example-cards" }


export default /*@__PURE__*/_defineComponent({
  __name: 'ExamplePage',
  setup(__props) {

// 若有额外逻辑可在此添加

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[12] || (_cache[12] = _createElementVNode("div", { class: "page-header" }, [
      _createElementVNode("h1", null, "案例展示"),
      _createElementVNode("p", null, " 以下是我们的一些成功案例，展示了我们在不同领域的专业能力和出色成果。 ")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_card, {
        class: "example-card",
        shadow: "hover"
      }, {
        header: _withCtx(() => _cache[0] || (_cache[0] = [
          _createElementVNode("h2", null, "案例一：智能电商系统开发", -1)
        ])),
        default: _withCtx(() => [
          _cache[2] || (_cache[2] = _createElementVNode("img", {
            src: "https://via.placeholder.com/300x200?text=E-commerce+System",
            alt: "案例一图片"
          }, null, -1)),
          _cache[3] || (_cache[3] = _createElementVNode("p", null, " 为一家知名电商企业开发了一套智能电商系统，集成了先进的数据分析和人工智能技术，显著提升了用户购物体验和企业运营效率。 ", -1)),
          _createVNode(_component_el_button, { type: "primary" }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [
              _createTextVNode("查看详情")
            ])),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_card, {
        class: "example-card",
        shadow: "hover"
      }, {
        header: _withCtx(() => _cache[4] || (_cache[4] = [
          _createElementVNode("h2", null, "案例二：大数据可视化平台搭建", -1)
        ])),
        default: _withCtx(() => [
          _cache[6] || (_cache[6] = _createElementVNode("img", {
            src: "https://via.placeholder.com/300x200?text=Big+Data+Visualization",
            alt: "案例二图片"
          }, null, -1)),
          _cache[7] || (_cache[7] = _createElementVNode("p", null, " 帮助某金融机构搭建了大数据可视化平台，通过直观的图表和报表展示，让复杂的数据变得易于理解，为决策提供了有力支持。 ", -1)),
          _createVNode(_component_el_button, { type: "primary" }, {
            default: _withCtx(() => _cache[5] || (_cache[5] = [
              _createTextVNode("查看详情")
            ])),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_card, {
        class: "example-card",
        shadow: "hover"
      }, {
        header: _withCtx(() => _cache[8] || (_cache[8] = [
          _createElementVNode("h2", null, "案例三：移动应用开发与推广", -1)
        ])),
        default: _withCtx(() => [
          _cache[10] || (_cache[10] = _createElementVNode("img", {
            src: "https://via.placeholder.com/300x200?text=Mobile+App",
            alt: "案例三图片"
          }, null, -1)),
          _cache[11] || (_cache[11] = _createElementVNode("p", null, " 为一款生活服务类移动应用进行了开发和推广，通过精准的市场定位和营销策略，迅速获得了大量用户，提升了品牌知名度。 ", -1)),
          _createVNode(_component_el_button, { type: "primary" }, {
            default: _withCtx(() => _cache[9] || (_cache[9] = [
              _createTextVNode("查看详情")
            ])),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ]))
}
}

})